import { CouriersRepository } from '../repositories/couriers.repository'
import { GetCallsParamsT, GetCallsResponseT } from '../types/calls.types'
import {
    CarChangeStatusPayload,
    CourierCarCreatePayloadT,
    CourierCarPayloadT,
    CourierPayloadT,
    CouriersCloseDayResponseT,
    CouriersCreateCourierResponseT,
    CouriersDownloadCourierPayloadT,
    CouriersDownloadCourierResponseT,
    CouriersGetCarResponseT,
    CouriersGetCarsResponseT,
    CouriersGetCarsStatusesT,
    CouriersGetCourierResponseT,
    CouriersGetListResponseT,
    CouriersGetVehicleTypesResponseT,
    CouriersUpdateCourierResponseT,
    VehicleTypePayload,
    CouriersGetParamsT,
    SchedulePayload,
    CouriersCreateCarResponseT,
    CouriersGetTypesResponseT
} from '../types/couriers.types'

const couriersRepository = new CouriersRepository()

export class CouriersService {
    async getList(params: any): Promise<CouriersGetListResponseT> {
        const response = await couriersRepository.getList(params)
        return response.data
    }

    async getCourierTypes(): Promise<CouriersGetTypesResponseT> {
        const response = await couriersRepository.getCourierTypes()
        return response.data
    }

    async getCalls(params: GetCallsParamsT): Promise<GetCallsResponseT> {
        const response = await couriersRepository.getCalls(params)
        return response.data
    }

    async createCourier(courier_payload: FormData): Promise<CouriersCreateCourierResponseT> {
        const response = await couriersRepository.createCourier(courier_payload)
        return response.data
    }

    async createCategory(category_payload: VehicleTypePayload): Promise<void> {
        await couriersRepository.createCategory(category_payload)
    }

    async createSchedule(schedule_payload: SchedulePayload): Promise<void> {
        await couriersRepository.createSchedule(schedule_payload)
    }

    async createJira(): Promise<void> {
        await couriersRepository.createJira()
    }

    async updateCourier(
        courier_id: number,
        courier_payload: CourierPayloadT
    ): Promise<CouriersUpdateCourierResponseT> {
        const response = await couriersRepository.updateCourier(courier_id, courier_payload)
        return response.data
    }

    async updateCategory(category_id: number, category_payload: VehicleTypePayload): Promise<void> {
        await couriersRepository.updateCategory(category_id, category_payload)
    }

    async deleteCourier(courier_id: number): Promise<void> {
        await couriersRepository.deleteCourier(courier_id)
    }

    async deleteCategory(category_id: number): Promise<void> {
        await couriersRepository.deleteCategory(category_id)
    }

    async getVehicleTypes(page: number): Promise<CouriersGetVehicleTypesResponseT> {
        const response = await couriersRepository.getVehicleTypes(page)
        return response.data
    }

    async exportExcel(
        params: CouriersDownloadCourierPayloadT
    ): Promise<CouriersDownloadCourierResponseT> {
        const response = await couriersRepository.exportExcel(params)
        return response.data
    }

    async setCheckupStatus(courier_id: number): Promise<void> {
        const response = await couriersRepository.setCheckupStatus(courier_id)
        return response.data
    }

    async setActiveStatus(courier_id: number): Promise<void> {
        const response = await couriersRepository.setActiveStatus(courier_id)
        return response.data
    }

    async setArchiveStatus(courier_id: number): Promise<void> {
        const response = await couriersRepository.setArchiveStatus(courier_id)
        return response.data
    }

    async getCourier(courier_id: number): Promise<CouriersGetCourierResponseT> {
        const response = await couriersRepository.getCourier(courier_id)
        return response.data
    }

    async uploadDocument(courier_id: number, form_data: FormData): Promise<void> {
        const response = await couriersRepository.uploadDocument(courier_id, form_data)
        return response.data
    }

    async uploadCarDocument(car_id: number, form_data: FormData): Promise<void> {
        const response = await couriersRepository.uploadCarDocument(car_id, form_data)
        return response.data
    }

    async getCars(params: CouriersGetParamsT): Promise<CouriersGetCarsResponseT> {
        const response = await couriersRepository.getCars(params)
        return response.data
    }

    async getCar(car_id: number): Promise<CouriersGetCarResponseT> {
        const response = await couriersRepository.getCar(car_id)
        return response.data
    }

    async createCar(car_payload: CourierCarCreatePayloadT): Promise<CouriersCreateCarResponseT> {
        const response = await couriersRepository.createCar(car_payload)
        return response.data
    }

    async updateCar(car_id: number, car_payload: CourierCarPayloadT): Promise<void> {
        const response = await couriersRepository.updateCar(car_id, car_payload)
        return response.data
    }

    async deleteCar(car_id: number): Promise<void> {
        const response = await couriersRepository.deleteCar(car_id)
        return response.data
    }

    async getCarsStatuses(params: any): Promise<CouriersGetCarsStatusesT> {
        const response = await couriersRepository.getCarsStatuses(params)
        return response.data
    }

    async changeCarStatus(payload: CarChangeStatusPayload): Promise<void> {
        const response = await couriersRepository.changeCarStatus(payload)
        return response.data
    }

    async closeDay(courier_id: number, date: string | null): Promise<CouriersCloseDayResponseT> {
        const response = await couriersRepository.closeDay(courier_id, date)
        return response.data
    }

    async saveShortcoming(payload: FormData): Promise<void> {
        const response = await couriersRepository.saveShortcoming(payload)
        return response.data
    }

    async savePaymentTakes(payload: FormData): Promise<void> {
        const response = await couriersRepository.savePaymentTakes(payload)
        return response.data
    }

    async savePaymentDeliveries(payload: FormData): Promise<void> {
        const response = await couriersRepository.savePaymentDeliveries(payload)
        return response.data
    }

    async rejectCourier(courier_id: number): Promise<void> {
        const response = await couriersRepository.rejectCourier(courier_id)
        return response.data
    }
}
